module.exports = "@media (max-width: 480px){.widget-1-wrapper{height:340px}}\n"